import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Wallet.svg'

export const IconWallet = IconSVG as IconComponent
